import { render, staticRenderFns } from "./hiContentType.vue?vue&type=template&id=d8a65bcc&"
import script from "./hiContentType.vue?vue&type=script&lang=js&"
export * from "./hiContentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports